import React, { Component } from 'react';
import classNames from 'classnames';
import { withContext } from '../utils/StateProvider';

// The row of names along the top of a trade that serves one character at a
// time: the market deals with whoever is at the counter, and the school
// teaches whoever is sitting in front of it.
class FacilityCharacters extends Component {

  render() {
    const { party, facilityCharacter, chooseFacilityCharacter } = this.props.context;

    return (
      <div className="facility-characters">
        {party.map((c, index) => (
          <button
            key={c.id}
            className={classNames('facility-character', { chosen: index === facilityCharacter })}
            onClick={() => chooseFacilityCharacter(index)}
          >
            <span className="training-slot">{index + 1}</span>
            <span className="facility-character-name">{c.name}</span>
            <span className="sheet-muted">{c.className}</span>
          </button>
        ))}
      </div>
    );
  }
}

export default withContext(FacilityCharacters);
